import { Injectable } from '@angular/core';
import { Router, CanActivate, NavigationEnd } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable()
export class AuthGuardService implements CanActivate {
    
    constructor(private router: Router,
                private authService: AuthService) 
    {
        router.events.subscribe( val => {
            if (val  instanceof NavigationEnd) {
                if (val.url == "/login" && authService.isLoggedIn()) {
                    this.router.navigate(['dashboard']);
                }
            }
        } )
    }

    canActivate() {        
        if (this.authService.isLoggedIn()) {        
            return true;
        } else {
            this.router.navigate(['login']);
            return false;
        }
    }
}


// WEBPACK FOOTER //
// C:/Users/Willi/Source/Repos/Reservation01/scr/reservation.client/src/app/services/auth-guard.service.ts